import { statusSolicitacaoAuditoriaOptions, statusSolicitacaoDiferenteAuditoriaOptions } from "@enums/StatusSolicitacao/Index";

// Opções de status para admin
export const statusAuditoriaOptions = statusSolicitacaoAuditoriaOptions.map((option) => ({
  value: option.value,
  label: option.label,
}));

// Opções de status para unidade/gerencia
export const statusAuditoriaUnidadeGerenciaOptions =
  statusSolicitacaoAuditoriaOptions
    .filter(o => !['PENDENTE_ENVIO', 'AGENDADO_ENVIO'].includes(o.value))
    .map(o => ({ value: o.value, label: o.label }));

// Componente versátil para exibir o status corretamente
const StatusSolicitacaoComp = ({ status, options }) => {
  // 🔍 Lista padrão se options não for passada
  const defaultOptions = [
    ...statusSolicitacaoAuditoriaOptions,
    ...statusSolicitacaoDiferenteAuditoriaOptions
  ];

  const list = options ?? defaultOptions;

  const statusObj = list.find(opt =>
    opt.value === status ||
    (typeof status === "number" && opt.intValue === status) ||
    (typeof status === "string" && String(opt.value) === status)
  );

  return <span>{statusObj ? statusObj.label : 'Status desconhecido'}</span>;
};

export default StatusSolicitacaoComp;
